<div class="speech-bubble mat-elevation-z4">
  <div fxLayout="column" fxFlex style="padding:15px;">
    <div fxLayout="row" fxLayoutAlign="center center center" style="height:40px;"><span fxFlex>{{title}}</span> <span (click)="close()" style="cursor: pointer"><mat-icon>close</mat-icon></span></div>
    <div fxLayout="row" fxLayoutAlign="center center center" fxFlexAlign="center" style="font-size: 12px;height:60px; margin-top:10px;">{{description}}</div>
    <div fxLayout="row" fxLayoutAlign="center center center" style="height: 20px; margin-top:25px;">
      <button fxFlexAlign="center" mat-raised-button class="bubble-button" (click)="showAnnouncement(id)">Προβολή</button>
    </div>

  </div>
</div>
